"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgYoutube = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M22.487 6.52c-.25-1.063-.988-1.905-1.935-2.19-1.712-.508-8.558-.508-8.558-.508s-6.722-.032-8.434.476c-.946.286-1.85 1.159-2.101 2.222-.46 1.937-.417 5.953-.417 5.953s-.042 4.016.417 5.952c.25 1.064 1.169 1.937 2.101 2.223 1.712.524 8.434.476 8.434.476s6.721.032 8.433-.476c.946-.286 1.823-1.16 2.073-2.223.46-1.92.46-5.952.46-5.952s-.014-4.016-.473-5.953zM9.892 16.314V8.631l5.47 3.842-5.47 3.841z" })));
};
exports.default = SvgYoutube;
//# sourceMappingURL=Youtube.js.map